import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNotifications } from "../context/NotificationContext";
import "../Styles/Notification.css";

const Notification = () => {
  const { userData } = useContext(AuthContext);
  const { notifications } = useNotifications();

  const user = userData?.[0];

  return (
    <div className="notification-content">
      <h2 className="notification-page-title">Notifications</h2>
      {!user ? (
        <p>Loading...</p>
      ) : notifications.length === 0 ? (
        <p className="notification-empty">No notifications.</p>
      ) : (
        <ul className="notifications-list">
          {notifications.map((n, idx) => (
            <li key={n.NM_ID ?? idx} className="notification-item">
              <p className="notification-message">{n.NM_Message ?? n.message}</p>
              <p className="notification-details notification-time">
                {n.CreatedDate ?? n.createdDate
                  ? new Date(n.CreatedDate ?? n.createdDate).toLocaleString()
                  : ""}
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Notification;
